function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 18.6667C5.71667 18.6667 4.67833 19.7167 4.67833 21C4.67833 22.2833 5.71667 23.3333 7 23.3333C8.28333 23.3333 9.33333 22.2833 9.33333 21C9.33333 19.7167 8.28333 18.6667 7 18.6667ZM0 0V2.33333H2.33333L6.53333 11.1883L4.95833 14.0467C4.77167 14.3733 4.66667 14.7583 4.66667 15.1667C4.66667 16.45 5.71667 17.5 7 17.5H21V15.1667H7.49C7.32667 15.1667 7.19833 15.0383 7.19833 14.875L7.23333 14.735L8.28333 12.8333H16.975C17.85 12.8333 18.62 12.355 19.0167 11.6317L23.1933 4.06C23.2867 3.89667 23.3333 3.69833 23.3333 3.5C23.3333 2.85833 22.8083 2.33333 22.1667 2.33333H4.91167L3.815 0H0ZM18.6667 18.6667C17.3833 18.6667 16.345 19.7167 16.345 21C16.345 22.2833 17.3833 23.3333 18.6667 23.3333C19.95 23.3333 21 22.2833 21 21C21 19.7167 19.95 18.6667 18.6667 18.6667Z",
  fill: "black"
});

var SvgIconCart1 = function SvgIconCart1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCart1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-cart-1.5859b5ea.svg";
export { ForwardRef as ReactComponent };